
import { BAG_STATUS } from '@bagonboard/wiseman';

const {
  DELIVERED,
  IN_TRANSIT,
  LOST,
  REJECTED,
  STORED,
  TO_PICKUP,
} = BAG_STATUS;

export default function getServiceStatusDetails(status) {
  switch (status) {
    case TO_PICKUP:
      return {
        color: '#1973e8',
        text : 'To Pickup',
      };
    case IN_TRANSIT:
      return {
        color: '#9b770e',
        text : 'In Transit',
      };
    case STORED:
      return {
        color: '#9b770e',
        text : 'Stored',
      };
    case DELIVERED:
      return {
        color: '#39A472',
        text : 'Delivered',
      };
    case LOST:
      return {
        color: '#d0505f',
        text : 'Lost',
      };
    case REJECTED:
      return {
        color: '#d0505f',
        text : 'Rejected',
      };
    default:
      return {
        color: '#1973e8',
        text : 'To Pickup',
      };
  }
}
